import React from 'react';
import Downshift from 'downshift';
import { withStyles } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import FetchSuggestions from './FetchSuggestions';

// const EmptyState = styled.div`
//   display: block;
//   padding: 15px 10px;
//   cursor: pointer;
//   font-size: 16px;
//   text-align: left;
//   .highlight {
//     font-weight: bold;
//     color: black;
//   }
// `;

function renderSuggestion({
  suggestion,
  index,
  itemProps,
  highlightedIndex,
  selectedItem,
}) {
  const isHighlighted = highlightedIndex === index;
  const isSelected = (selectedItem || '').indexOf(suggestion) > -1;

  return (
    <MenuItem
      {...itemProps}
      key={`suggestion-item-${index}`}
      selected={isHighlighted}
      component="div"
      style={{
        fontWeight: isSelected ? 500 : 400,
        padding: '20px 10px',
        fontSize: '16px',
        fontFamily: 'Libre Franklin',
      }}
    >
      {suggestion}
    </MenuItem>
  );
}

const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  container: {
    flexGrow: 1,
    position: 'relative',
  },
  paper: {
    top: '100%',
    position: 'absolute',
    zIndex: 10,
    left: 0,
    right: 0,
    fontFamily: '"Libre Franklin", sans-serif',
  },
  chip: {
    margin: `${theme.spacing(1 / 2)}px ${theme.spacing(1 / 4)}px`,
  },
  inputRoot: {
    flexWrap: 'wrap',
  },
});

const DownshiftInput = props => {
  const handleSelect = selectedItem => {
    props.selectSuggestions({ selectedItem });
  };

  const { classes, defaultInputValue } = props;

  return (
    <Downshift
      onSelect={handleSelect}
      defaultInputValue={defaultInputValue}
      id="autocomplete"
      labelId="autocomplete-label"
      inputId="autocomplete-input"
      menuId="autocomplete-menu"
      onInputValueChange={props.onInputValueChange}
      stateReducer={(state, changes) => {
        if (
          changes.type === Downshift.stateChangeTypes.mouseUp ||
          changes.type === Downshift.stateChangeTypes.blurInput
        ) {
          return {
            ...changes,
            inputValue: state.inputValue,
          };
        }
        return changes;
      }}
    >
      {({
        getInputProps,
        getItemProps,
        isOpen,
        inputValue,
        selectedItem,
        highlightedIndex,
        clearItems,
        closeMenu,
        setState,
      }) => (
        <div className={classes.container}>
          {props.renderInput({
            classes,
            InputProps: getInputProps({
              placeholder: props.placeholder,
              id: props.id,
              autoComplete: 'off',
            }),
            closeMenu,
            setState,
          })}
          {isOpen ? (
            <FetchSuggestions
              searchValue={inputValue}
              onLoaded={() => {
                clearItems();
              }}
              limit={4}
              render={({ loading, suggestions, error }) => (
                <Paper className={classes.paper} elevation={2} square>
                  {!(loading && error && suggestions.length === 0)
                    ? suggestions.map((suggestion, index) =>
                        renderSuggestion({
                          suggestion,
                          index,
                          itemProps: getItemProps({ item: suggestion }),
                          highlightedIndex,
                          selectedItem,
                        })
                      )
                    : null}
                </Paper>
              )}
            />
          ) : null}
        </div>
      )}
    </Downshift>
  );
};

export default React.memo(withStyles(styles)(DownshiftInput));
